<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="terminal-status-submenu-panel">
	<ul>
		<li *ngFor="let status of statusList">
			<!--<input type="checkbox" [(ngModel)]="status.active" name="active" (change)="changeStatus()" /> {{status.display}}-->
			<p-checkbox name="active" label="{{status.display}}" binary="true" (onChange)="changeStatus()"  [(ngModel)]="status.active"></p-checkbox>
		</li>
	</ul>
</div>